import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { Provider } from 'react-redux'
import { migrateAuthStorage } from './auth/authStorage'
import { store } from './store/store'
import { setTheme } from './store/themeSlice'
import RoutesAndTheme from './RoutesAndTheme'
import './styles/index.css'
import './translation/i18n'
import 'react-toastify/dist/ReactToastify.css'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || __APP_VERSION__,
    sendDefaultPii: true,
  });
}

// Clear legacy/stale auth state before the app restores any session-derived data.
migrateAuthStorage();

// Initialize theme from localStorage
const savedMode = localStorage.getItem('darkMode');
const isDark = savedMode === 'true';
store.dispatch(setTheme(isDark ? 'dark' : 'light'));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <RoutesAndTheme />
    </Provider>
  </StrictMode>,
)
